module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar fieldConfig = model.config || {};\n%>\n<div data-field-code=\"<%- model.fieldCode || '' %>\">\n<%\nif((fieldConfig.showExtendedControls || {}).reset !== false){\n%><%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'products', mode: 'empty', symbolOnly: true } }); %><%\n}\n%>\n<%- include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'products' } }); %>\n<%- include('./selection', { model: model }); %>\n</div>"
  , __filename = "components/templates/mblx/products/picker/button.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var fieldConfig = model.config || {};

    ; __line = 3
    ; __append("\n<div data-field-code=\"")
    ; __line = 4
    ; __append( model.fieldCode || '' )
    ; __append("\">\n")
    ; __line = 5
    ; 
if((fieldConfig.showExtendedControls || {}).reset !== false){

    ; __line = 7
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'products', mode: 'empty', symbolOnly: true } }) )
    ; 
}

    ; __line = 9
    ; __append("\n")
    ; __line = 10
    ; __append( include('../../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showSelect', context: 'products' } }) )
    ; __append("\n")
    ; __line = 11
    ; __append( include('./selection', { model: model }) )
    ; __append("\n</div>")
    ; __line = 12
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/products/picker/button.ejs

}